
<template>
  <div>
    <el-dialog
      :visible.sync="show"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      title="更改环境"
      width="600px"
    >
      <div class="g-mb-20">
        <el-row :gutter="20">
          <el-col :span="8">熊良</el-col>
          <el-col :span="8">http://192.168.1.12:8081/</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">赵江南</el-col>
          <el-col :span="8">http://192.168.3.184:9092/</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">赵宗其</el-col>
          <el-col :span="8">http://192.168.1.44:2345/</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">祝树鹏</el-col>
          <el-col :span="8">http://192.168.1.34:8086/</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">预发布</el-col>
          <el-col :span="8">http://47.110.38.79:9121/</el-col>
        </el-row>
      </div>
      <el-form
        ref="form"
        :model="form"
        label-width="70px"
      >
        <el-form-item label="开发环境">
          <el-select
            v-model="form.env"
            placeholder="请选择开发环境"
          >
            <el-option
              label="熊良"
              value="/willie"
            />
            <el-option
              label="赵江南"
              value="/jiangnan"
            />
            <el-option
              label="祝树鹏"
              value="/laoge"
            />
            <el-option
              label="赵宗其"
              value="/xiaopang"
            />
            <el-option
              label="测试环境"
              value=""
            />
            <el-option
              label="预发布"
              value="/yufabu"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取消</el-button>
        <el-button
          type="primary"
          @click="submit"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
	<script>
  export default {
    name: 'env-add',

    mixins: [],
    data() {
      return {
        show: false,
        form: {
          env: ''
        }
      };
    },
    watch: {
      show(v) {
        if (v) {
          this.form.env = localStorage.getItem('personUrl') || '';
        } else {
          this.$emit('destory');
        }
      }
    },
    mounted() {
    },
    methods: {
      handleClose() {
        this.$emit('close');
      },
      submit() {
        localStorage.setItem('personUrl', this.form.env);
        this.$emit('sure');
      },
    },
  };
	</script>

  <style scoped>
</style>


// WEBPACK FOOTER //
// src/components/develop-person/index.vue